import {observer} from "mobx-react";
import * as React from "react";
import {useNavigate} from "react-router-dom";
import {useNavigatorFeature} from "../../useFeature";
import LayoutContentToolbar from "../../components/layout/LayoutContentToolbar";
import Table from "../../components/table/Table"
import LayoutContentWrapper from "../../components/layout/LayoutContentWrapper";
import {useApplication} from "../../ApplicationProvider";
import ListCustomerOnboardingFeature from "./ListCustomerOnboardingFeature";
import AddIcon from "@mui/icons-material/Add";
import FilledButton from "../../components/buttons/FilledButton";
import {renderAuthorizationStateIcon} from "../../components/state/AuthorizationStateRenderer";
import SyncIcon from "@mui/icons-material/Sync";
import {Box} from "@mui/material";
import CuitFormatter from "../../utils/CuitRenderer";

function ListCustomerOnboardingScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const feature = useNavigatorFeature(() => new ListCustomerOnboardingFeature(application, navigator), navigator);
    const cuitFormatter = new CuitFormatter();

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const listCustomerOnboardingsContent = () => {
        return (
            <div>
                <LayoutContentToolbar title="Altas de Clientes">
                    <Box sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                        {application.hasOnboardingERPImporterPermission() && (
                            <FilledButton
                                onClick={() => feature.synchronizeERP()}
                                loading={feature.buttonLoading}
                                variant="contained"
                                disabled={feature.buttonLoading}>
                                {feature.buttonLoading ? "Sincronizando..." : "Sincronización con ERP"}
                                <SyncIcon fontSize="small" style={{marginLeft: '8px'}}/>
                            </FilledButton>
                        )}
                        {application.hasCloserPermission() && (
                            <FilledButton onClick={() => feature.navigateToCreateCustomerOnboardingRequest()}>
                                <AddIcon fontSize="small"/>
                                Iniciar alta de cliente
                            </FilledButton>
                        )}
                    </Box>
                </LayoutContentToolbar>
                <Table
                    columns={feature.columnsContent()}
                    rows={feature.presentedCustomerOnboardings()}
                    navigateToRowObjectScreen={(params) => feature.navigateToCustomerOnboardingEditionScreen(params.row)}
                    columnsRenderer={{
                        taxpayerIdentificationNumber: (params) => cuitFormatter.format(params.value),
                        logisticsAuthorization: renderAuthorizationStateIcon,
                        commercialAuthorization: renderAuthorizationStateIcon,
                        financeAuthorization: renderAuthorizationStateIcon,
                        taxAuthorization: renderAuthorizationStateIcon
                    }}
                />
            </div>
        )
    }

    return (
        <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => listCustomerOnboardingsContent()}/>
    )
}

export default observer(ListCustomerOnboardingScreen)
